var map = {
	"./": 72812,
	"./App": 23290,
	"./App.css": 44050,
	"./App.js": 23290,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./InfoData": 14098,
	"./InfoData.js": 14098,
	"./assets/files/jarvis_tse_cv.pdf": 70884,
	"./assets/fonts/SourceCodePro-Bold.ttf": 30692,
	"./assets/fonts/SourceCodePro-Regular.ttf": 97611,
	"./assets/images/about_bg.png": 91752,
	"./assets/images/projects/book-silk-road/01_codex_demo_1.png": 81388,
	"./assets/images/projects/book-silk-road/02_codex_demo_2.png": 2890,
	"./assets/images/projects/book-silk-road/03_codex_demo_3.png": 6720,
	"./assets/images/projects/book-silk-road/04_admin_home.png": 64439,
	"./assets/images/projects/book-silk-road/05_admin_book_edit.png": 98871,
	"./assets/images/projects/book-tracking/01_web_manage_book.png": 1312,
	"./assets/images/projects/book-tracking/02_web_search_book.png": 27892,
	"./assets/images/projects/book-tracking/03_web_bookDetails.png": 17342,
	"./assets/images/projects/book-tracking/04_web_track_book.png": 35431,
	"./assets/images/projects/book-tracking/05_web_AllReaderResult.jpg": 78416,
	"./assets/images/projects/book-tracking/10_app_main.png": 79015,
	"./assets/images/projects/book-tracking/11_app_search.png": 45199,
	"./assets/images/projects/book-tracking/12_app_track.png": 74141,
	"./assets/images/projects/book-tracking/20_hardward.png": 43414,
	"./assets/images/projects/coiner/IMG_7301.PNG": 94985,
	"./assets/images/projects/coiner/IMG_7302.PNG": 46866,
	"./assets/images/projects/coiner/IMG_7303.PNG": 86203,
	"./assets/images/projects/coiner/IMG_7304.PNG": 3332,
	"./assets/images/projects/coiner/IMG_7305.PNG": 73357,
	"./assets/images/projects/coiner/IMG_7306.PNG": 4182,
	"./assets/images/projects/coiner/IMG_7307.PNG": 69311,
	"./assets/images/projects/coiner/IMG_7308.PNG": 25352,
	"./assets/images/projects/coiner/IMG_7309.PNG": 49681,
	"./assets/images/projects/coiner/IMG_7310.PNG": 92235,
	"./assets/images/projects/cover/book-silk-road.png": 37228,
	"./assets/images/projects/cover/book-tracking.png": 64259,
	"./assets/images/projects/cover/coiner.png": 16968,
	"./assets/images/projects/cover/digital-collections.png": 60344,
	"./assets/images/projects/cover/e-signature.png": 73460,
	"./assets/images/projects/cover/faceswap.jpg": 30256,
	"./assets/images/projects/cover/filepicker.png": 92494,
	"./assets/images/projects/cover/frenchmay.png": 54795,
	"./assets/images/projects/cover/hidden-stories.png": 70990,
	"./assets/images/projects/cover/i-create.png": 33816,
	"./assets/images/projects/cover/itrain.png": 69575,
	"./assets/images/projects/cover/masksapp.png": 25438,
	"./assets/images/projects/cover/scifest.png": 52221,
	"./assets/images/projects/digital-collections/01_home_page.png": 76844,
	"./assets/images/projects/digital-collections/02_repository_page.png": 3588,
	"./assets/images/projects/digital-collections/03_repository_list.png": 33528,
	"./assets/images/projects/digital-collections/04_collection_item_list.png": 96003,
	"./assets/images/projects/digital-collections/05_collection_item_page.png": 20037,
	"./assets/images/projects/e-signature/00_e-signature.png": 52552,
	"./assets/images/projects/e-signature/01_e-signature.mp4": 57260,
	"./assets/images/projects/faceswap/01_demo.jpg": 96236,
	"./assets/images/projects/faceswap/02_demo.jpg": 81053,
	"./assets/images/projects/faceswap/03_demo.jpg": 33346,
	"./assets/images/projects/faceswap/04_demo.jpg": 48235,
	"./assets/images/projects/faceswap/05_demo.jpg": 9728,
	"./assets/images/projects/frenchmay/IMG_7316.PNG": 61378,
	"./assets/images/projects/frenchmay/IMG_7317.PNG": 78347,
	"./assets/images/projects/frenchmay/IMG_7318.PNG": 84732,
	"./assets/images/projects/frenchmay/IMG_7319.PNG": 47365,
	"./assets/images/projects/frenchmay/IMG_7320.PNG": 64745,
	"./assets/images/projects/frenchmay/IMG_7321.PNG": 61824,
	"./assets/images/projects/frenchmay/IMG_7322.PNG": 55963,
	"./assets/images/projects/frenchmay/IMG_7323.PNG": 16626,
	"./assets/images/projects/frenchmay/IMG_7324.PNG": 59469,
	"./assets/images/projects/frenchmay/IMG_7325.PNG": 89444,
	"./assets/images/projects/frenchmay/IMG_7326.PNG": 55423,
	"./assets/images/projects/frenchmay/IMG_7327.PNG": 90294,
	"./assets/images/projects/frenchmay/IMG_7328.PNG": 19441,
	"./assets/images/projects/frenchmay/IMG_7329.PNG": 95112,
	"./assets/images/projects/frenchmay/IMG_7330.PNG": 46478,
	"./assets/images/projects/frenchmay/IMG_7331.PNG": 63255,
	"./assets/images/projects/frenchmay/IMG_7332.PNG": 99068,
	"./assets/images/projects/hidden-stories/01_home_page_1.png": 13222,
	"./assets/images/projects/hidden-stories/02_home_page_2.png": 14622,
	"./assets/images/projects/hidden-stories/03_people_page.png": 17596,
	"./assets/images/projects/hidden-stories/04_research_page.png": 81877,
	"./assets/images/projects/i-create/00_lobby.png": 52632,
	"./assets/images/projects/i-create/01_appointment.png": 88862,
	"./assets/images/projects/i-create/02_gsic_edit.png": 23675,
	"./assets/images/projects/i-create/03_poster_edit.png": 27849,
	"./assets/images/projects/i-create/04_booth_index.png": 39641,
	"./assets/images/projects/i-create/05_booth_detail.png": 74781,
	"./assets/images/projects/i-create/06_gsic_index.png": 12367,
	"./assets/images/projects/i-create/07_webinar_date.png": 91854,
	"./assets/images/projects/i-create/08_webinar_view_1.png": 31036,
	"./assets/images/projects/i-create/09_webinar_view_2.png": 75240,
	"./assets/images/projects/i-create/10_webinar_view_3.png": 33307,
	"./assets/images/projects/i-create/11_webinar_view_4.png": 54199,
	"./assets/images/projects/i-create/12_webinar_view_5.png": 93587,
	"./assets/images/projects/masksapp/01_home.png": 11998,
	"./assets/images/projects/masksapp/01_mask_detail.png": 64391,
	"./assets/images/projects/masksapp/03_comment.png": 88378,
	"./assets/images/projects/masksapp/04_intelligence.png": 79901,
	"./assets/images/projects/masksapp/05_view_comment.png": 26114,
	"./assets/images/projects/masksapp/06_view_intelligence.png": 35971,
	"./assets/images/projects/masksapp/07_location.png": 39224,
	"./assets/images/projects/masksapp/08_create_mask.png": 40853,
	"./assets/images/projects/masksapp/09_create_trade.png": 40316,
	"./assets/images/projects/masksapp/10_trade_detail.png": 35235,
	"./assets/images/projects/masksapp/11_trade.png": 3018,
	"./assets/images/projects/masksapp/12_login.png": 41420,
	"./assets/images/projects/masksapp/13_singup.png": 64390,
	"./assets/images/projects/masksapp/14_account.png": 29780,
	"./assets/images/projects/masksapp/15_blog.png": 63498,
	"./assets/images/projects/masksapp/16_blog_detail.png": 40831,
	"./assets/images/projects/scifest/activity_detail.png": 17145,
	"./assets/images/projects/scifest/activity_edit.png": 62978,
	"./assets/images/projects/scifest/activity_index.png": 4436,
	"./assets/images/projects/scifest/booth_design.png": 8571,
	"./assets/images/projects/scifest/booth_detail_1.png": 53274,
	"./assets/images/projects/scifest/booth_detail_2.png": 77937,
	"./assets/images/projects/scifest/intro.png": 22718,
	"./assets/images/projects/scifest/lobby.png": 15720,
	"./assets/images/projects/scifest/login.png": 37715,
	"./assets/images/projects/scifest/reward.png": 66567,
	"./assets/images/projects/scifest/webinar_detail.png": 59236,
	"./assets/images/projects/scifest/webinar_index.png": 50355,
	"./assets/js/animatecss": 46542,
	"./assets/js/animatecss.js": 46542,
	"./components/AboutBg": 30711,
	"./components/AboutBg.js": 30711,
	"./components/AboutTextContainer": 20532,
	"./components/AboutTextContainer.css": 63339,
	"./components/AboutTextContainer.js": 20532,
	"./components/AnimateBg": 26384,
	"./components/AnimateBg.js": 26384,
	"./components/Card": 17379,
	"./components/Card.js": 17379,
	"./components/Carousel": 47547,
	"./components/Carousel.css": 44102,
	"./components/Carousel.js": 47547,
	"./components/Chip": 54211,
	"./components/Chip.js": 54211,
	"./components/ContactContainer": 99470,
	"./components/ContactContainer.js": 99470,
	"./components/Dialog": 60705,
	"./components/Dialog.js": 60705,
	"./components/Header": 68140,
	"./components/Header.js": 68140,
	"./components/ProjectDialog": 80695,
	"./components/ProjectDialog.js": 80695,
	"./components/SectionTitle": 10502,
	"./components/SectionTitle.js": 10502,
	"./components/SectionWrapper": 24399,
	"./components/SectionWrapper.js": 24399,
	"./components/SkillCloud": 44603,
	"./components/SkillCloud.js": 44603,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./logo.svg": 69445,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./sections/About": 2248,
	"./sections/About.js": 2248,
	"./sections/Education": 26791,
	"./sections/Education.js": 26791,
	"./sections/Experience": 10565,
	"./sections/Experience.js": 10565,
	"./sections/Project": 75296,
	"./sections/Project.js": 75296,
	"./sections/Skills": 86039,
	"./sections/Skills.js": 86039,
	"./setupTests": 89472,
	"./setupTests.js": 89472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;